import { useTranslation } from 'react-i18next';

import { StaticPageLayout } from '../components/layout/StaticPageLayout';

function Section({
  titleKey,
  children,
}: {
  titleKey: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <section>
      <h2 className="text-xl font-heading font-semibold text-brand-accent mb-3">
        {t(titleKey)}
      </h2>
      <p className="text-neutral-medium font-body leading-relaxed">{children}</p>
    </section>
  );
}

/** Date shown as "last updated" – adjust when you change the policy. */
const PRIVACY_LAST_UPDATED = '2025-01-01';

export function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <StaticPageLayout
      titleKey="staticPages.privacy.title"
      subtitleKey="staticPages.privacy.subtitle"
      lastUpdatedKey="staticPages.privacy.lastUpdated"
      date={PRIVACY_LAST_UPDATED}
    >
      <p className="text-neutral-medium font-body leading-relaxed">
        {t('staticPages.privacy.intro')}
      </p>
      <Section titleKey="staticPages.privacy.collect">
        {t('staticPages.privacy.collectText')}
      </Section>
      <Section titleKey="staticPages.privacy.use">
        {t('staticPages.privacy.useText')}
      </Section>
      <Section titleKey="staticPages.privacy.rights">
        {t('staticPages.privacy.rightsText')}
      </Section>
      <p className="text-neutral-medium font-body leading-relaxed pt-2">
        {t('staticPages.privacy.contact')}
      </p>
    </StaticPageLayout>
  );
}
